import { IFRResource } from "app/resources/ifrresource";
import { CompanyResource } from "app/resources/company/company-resource";

export class CompanyListResource extends IFRResource {

    companyListResource: CompanyResource[];
}
